import TimerComponentMeta from './Timer';
import WatchValueComponentMeta from './WatchValue';
export default [WatchValueComponentMeta, TimerComponentMeta];
//# sourceMappingURL=index.js.map
